var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"card-footer mb-4"},[_c('a',{staticClass:"card-footer-item",attrs:{"href":"#"},on:{"click":_vm.retry_command}},[_vm._v("Retry")]),_c('a',{staticClass:"card-footer-item",attrs:{"href":"#"},on:{"click":_vm.cancel_command}},[_vm._v("Cancel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }